// 导入api接口模块
import home from './home'

// 获取当前环境变量 true => 生产环境 false => 开发环境
export const BASEURL = (process.env.NODE_ENV === 'production') ? 'https://boyeapi.jidezhu.cn' : '/operate'

export const api = {
  // 登录模块
  ...home(BASEURL),

  // 登录模块
  getCode: `${BASEURL}/api/register/verify`, // 获取验证码
  login: `${BASEURL}/api/login`, // 登录
  register: `${BASEURL}/api/register`, // 注册
  getUserInfo: `${BASEURL}/api/userinfo`, // 获取用户信息

  // 商品模块
  getProductDetail: `${BASEURL}/api/pc/product/detail`, // 普通商品详情
  getSeckillDetail: `${BASEURL}/api/seckill/detail`, // 秒杀商品详情
  getCombinationDetail: `${BASEURL}/api/combination/detail`, // 拼团商品详情
  getBargainDetail: `${BASEURL}/api/bargain/detail`, // 砍价商品详情
  getPoster: `${BASEURL}/api/product/poster`, // 商品详情海报
  hotProduct: `${BASEURL}/api/product/hot`, // 热门推荐
  collect: `${BASEURL}/api/collect/add`, // 收藏
  uncollect: `${BASEURL}/api/collect/del`, // 取消收藏
  addCart: `${BASEURL}/api/cart/add`, // 加入购物车
  getCartNum: `${BASEURL}/api/cart/count`, // 获取购物车商品数量
  getCartList: `${BASEURL}/api/cart/list`, // 获取购物车列表
  cartNum: `${BASEURL}/api/cart/num`, // 修改购物车商品数量
  delCart: `${BASEURL}/api/cart/del`, // 删除购物车商品
  getReply: `${BASEURL}/api/reply/config`, // 获取商品评论数据
  getReplyList: `${BASEURL}/api/reply/list`, // 获取商品评论列表
  getSettlement: `${BASEURL}/api/order/confirm`, // 获取结算详情
  getStoreList: `${BASEURL}/api/store_list`, // 获取门店列表
  computedAmount: `${BASEURL}/api/order/computed`, // 计算结算金额
  createOrder: `${BASEURL}/api/order/create`, // 创建订单

  // 个人中心
  getCollect: `${BASEURL}/api/collect/user`, // 获取收藏/足迹
  editUserInfo: `${BASEURL}/api/user/edit`, // 修改用户信息
  upload: `${BASEURL}/api/api/upload`, // 上传
  getAddressList: `${BASEURL}/api/address/list`, // 获取地址列表
  setDefaultAddress: `${BASEURL}/api/address/default/set`, // 设为默认地址
  delAddress: `${BASEURL}/api/address/del`, // 删除地址
  getCityList: `${BASEURL}/api/city_list`, // 获取城市列表
  editAddress: `${BASEURL}/api/address/edit`, // 添加/修改地址
  getUserCoupons: `${BASEURL}/api/coupons/user`, // 用户已领取优惠券列表
  getCoupons: `${BASEURL}/api/coupons`, // 可领取优惠券列表
  receiveCoupon: `${BASEURL}/api/coupon/receive`, // 领取优惠券
  getOrderCoupons: `${BASEURL}/api/coupons/order`, // 订单可使用优惠券列表
  getOrderProduct: `${BASEURL}/api/order/product`, // 查询评价订单商品
  getSystemStoreInfo: `${BASEURL}/api/pc/getSystemStoreInfo` // 查询店铺信息
}
export default api



// WEBPACK FOOTER //
// ./src/api/index.js